import script from "./ForgotPasswordForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotPasswordForm.vue?vue&type=script&setup=true&lang=js"

import "./ForgotPasswordForm.vue?vue&type=style&index=0&id=0a1a1f72&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a1a1f72"]])

export default __exports__